import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BaseContactBox from './BaseContactBox';

const ContactScheduleBox = memo(({ value }) => (
  <BaseContactBox
    linkHref="#"
    classNames="contact-box--schedule"
    value={value}
  />
));

ContactScheduleBox.displayName = 'ContactScheduleBox';

ContactScheduleBox.propTypes = {
  value: PropTypes.string.isRequired
};

export default ContactScheduleBox;
